import type { NotificationType } from './types';

export function showNotification(title: string, message: string, type: NotificationType = 'success'): void {
  // Remove existing notification
  const existing = document.querySelector('.notification');
  if (existing) {
    existing.remove();
  }
  
  const notification = document.createElement('div');
  notification.className = `notification ${type}`;
  notification.innerHTML = `
    <div class="notification-title">${title}</div>
    <div class="notification-message">${message}</div>
  `;
  
  // Check if there's an open modal dialog and append notification to it
  const openDialog = document.querySelector('dialog[open]');
  const container = openDialog || document.body;
  
  container.appendChild(notification);
  
  // Show with animation
  setTimeout(() => notification.classList.add('show'), 50);
  
  // Auto-hide after 4 seconds
  setTimeout(() => {
    notification.classList.remove('show');
    setTimeout(() => notification.remove(), 300);
  }, 4000);
} 